import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import ExpenseList, { DispatchProps, OwnProps, StateProps } from './ExpenseList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getExpenses, getExpensesCsv } from 'src/store/actions/expense-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.expenses.data,
        inProgress: state.expenses.inProgress,
        providers: selectNameProviders(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getExpenses(params)),
        getDataCsv: (params: QueryParams) => dispatch(getExpensesCsv(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
    };
}

const ExpenseListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ExpenseList);

export default ExpenseListScreen;
